

import React, { useEffect, useContext, useState } from 'react';
import { Flex, Row, message, Divider, Dialo, Tabs } from 'antd';
import FormRender, { useForm } from 'form-render';
import { Dialog,  } from 'antd-mobile';
import { FormConfigProvider, FormConfigContext } from './provider';
import { CloseCircleOutlined } from '@ant-design/icons';
import GoodsDialog from '../dialog/goods';
import can from '../../../../components/ability';

const iconStyle = {
    fontSize: 28,
}



export default (props) => {
    
    const { value, onChange, schema } = props;
    const { multi = true } = schema;
    const [showChoose, setShowChoose] = useState(false);
    const [myList, setMyList] = useState([]);
    const [proxyList, setProxyList] = useState([]);
    const globalConfig = useContext(FormConfigContext);
    const { accId, shopId } = globalConfig;
    const getGoodsList = async (page = 1) => {
        let response = await fetch(`/api/goods/my-list?accId=${accId}&shopId=${shopId}&page=${page}&pageSize=10000`);
        let result = await response.json();

        if(result.success){
            return result.data?.rows || []
        }

        return [];
    }

    const getProxyGoodsList = async (page = 1) => {
        let response = await fetch(`/api/goods/proxy-list?accId=${accId}&shopId=${shopId}&page=${page}&pageSize=10000`);
        let result = await response.json();

        if(result.success){
            // 修改数据字段名，是满足proxy-card组件的展示
            return result.data?.rows || [];
            // return result.data.map(({shopId_shops, ...others}) => ({...others, shopId_shop_goods_shops: shopId_shops}));
        }

        return [];
    }
    function clearValue(e) {
        e.stopPropagation()
        onChange();
    }
    useEffect(() => {
        getGoodsList().then(res => setMyList(res));
        getProxyGoodsList().then(res => setProxyList(res));
        return;
    }, []);

    const showList = [];
    let forList = value || [];
    if (!Array.isArray(forList)) {
        forList=[value]
    }
    forList.forEach(v => {
        let find = proxyList.find(i => i.goodsId === v);
        if (find) {
            showList.push(find)
            return;
        }
        find = myList.find(i => i.goodsId === v);
        if (find) {
            showList.push(find)
            return;
        }
    })
    
    
    return (
        <div className='comp-form-customer-field'>
            <GoodsDialog
                visible={showChoose}
                onClose={() => setShowChoose(false)}
                onChange={(value) => {onChange(multi?value: value[0]); setShowChoose(false);}}
                multi={multi}
                value={showList.map(i => i.goodsId)}
                proxyList={proxyList}
                myList={myList}
            />
            <div className={`comp-form-choose-item ${showList.length > 0 ?'':'empty'}`} onClick={() => setShowChoose(true)}>
                {
                    showList.map(i => i.title).join(', ') || '选择商品'
                }
                <CloseCircleOutlined className='clear-value' onClick={clearValue} />
            </div>
        </div>
    );
};